import { FEATURE_FLAGS } from '../config/featureFlags';

/**
 * Where a notification should take the learner, or null for no link (KAN-533).
 *
 * The rule: link only to a page that is switched on. Most notifications today come from the
 * judgment pipeline, and its pages sit behind FEATURE_FLAGS.JUDGMENT_SURFACES (off since
 * KAN-455). With that flag off the route redirects home, so a link would be a dead end. In
 * that case the notification is shown as plain text.
 *
 * `flags` is a parameter so tests can check both states without flipping the real flag.
 */
export const notificationLink = (notification, flags = FEATURE_FLAGS) => {
  if (!notification) return null;
  const { notification_type: type, entity_type: entity, entity_id: id } = notification;

  // Judgment pipeline: judgment_submitted, execution_completed, outcome_resolved,
  // memory_entry_created. The pipeline page has no per-record address, so link to the page.
  if (['judgment', 'execution', 'outcome', 'memory_entry'].includes(entity)) {
    return flags.JUDGMENT_SURFACES ? '/judgment-pipeline' : null;
  }

  // Contributions, each behind its own flag.
  if (entity === 'new_word') {
    return flags.NEW_WORDS && id != null ? `/new-words/${id}` : null;
  }
  if (entity === 'challenge') {
    return flags.CHALLENGE_SUBMISSION && id != null ? `/challenges/${id}` : null;
  }
  if (entity === 'theory' || entity === 'learning_theory') {
    return flags.LEARNING_THEORY && id != null ? `/learning-theories/${id}` : null;
  }

  // Reputation and invites carry no entity; their pages are not flagged.
  if (type === 'reputation_awarded' || type === 'invite_accepted') {
    return '/me/reputation';
  }

  return null;
};

/** Event the inbox fires after marking something read, so the header badge refreshes at once. */
export const NOTIFICATIONS_CHANGED_EVENT = 'fc:notifications-changed';
